import { useEffect, useMemo } from 'react';

import useWorkspaceRouter from '@/hooks/domain/useWorkspaceRouter';
import useUserStore from '@/stores/UserStore';
import useWorkspaceStore from '@/stores/WorkspaceStore';

import useUserRole from './useUserRole';

const useRedirect = () => {
  const { isEditor } = useUserRole();
  const { user } = useUserStore((state) => ({ user: state.user }));
  const { currWorkspace, currWorkspaceMembers } = useWorkspaceStore(
    (state) => ({
      currWorkspace: state.currWorkspace,
      currWorkspaceMembers: state.currWorkspaceMembers,
    }),
  );
  const { navigate } = useWorkspaceRouter();

  const wa = useMemo(() => currWorkspace?.alias, [currWorkspace?.alias]);

  useEffect(() => {
    if (user && currWorkspaceMembers.length > 0 && wa && !isEditor) {
      navigate(`/workspace/${wa}`);
    }
  }, [wa, user, isEditor, currWorkspaceMembers, navigate]);
};

export default useRedirect;
